import { TabsReducer } from '../../../../common/tabs/tabs.reducer';
import {IDS} from '../import-settings-action-id.constants';
export const EmpImportSettingsCentersTabs = {
    [IDS.app_employees_import_settings_centers]: Object.assign(TabsReducer(), {
        tabs: [{
            state: IDS.app_employees_import_settings_centers_list,
            title: 'Cost Centers',
            visible: true,
            disabled: false,
            loading: false
        },
        {
            state: IDS.app_employees_import_settings_centers_details,
            title: 'Cost Center Details',
            visible: false,
            disabled: false,
            loading: false,
            buttons: {
                // execute: {label: 'Download'}
            }
        }]
    }),
};
